import { Factory, trait } from 'miragejs';

export default Factory.extend({
  admin: trait({
    name() {
      return 'Admin';
    },

    id() {
      return '1';
    },
  }),

  editor: trait({
    name() {
      return 'Editor';
    },

    id() {
      return '2';
    },
  }),

  job: trait({
    name() {
      return 'Job';
    },

    id() {
      return '4';
    },
  }),

  readOnly: trait({
    name() {
      return 'Read Only';
    },

    id() {
      return '12';
    },
  }),

  umgClassicEvent: trait({
    name() {
      return 'UMG Classic Event';
    },

    id() {
      return '25';
    },
  }),

  management: trait({
    name() {
      return 'Management';
    },

    id() {
      return '20';
    },
  }),

  customerSupport: trait({
    name() {
      return 'Customer Support';
    },

    id() {
      return '32';
    },
  }),

  noPermissions: trait({
    name() {
      return 'No Permissions';
    },

    id() {
      return '0';
    },
  }),
});
